module.exports = __webpack_public_path__ + "img/emm_icon01.45d78029.png";